<template>
  <div ref="host" class="ecc-host ecc-host--fullscreen">
    <div class="ecc-stage" dir="rtl" data-screen-label="TV" :style="{ transform: ui.stageTransform }">

      <header class="ecc-header">
        <div class="ecc-row ecc-row--gap20">
          <img :src="logo" contain width="34px" height="34px" class="logo ecc-logo-btn" title="باز کردن منو"
            @click="openMenu" />
          <div class="ecc-header__title">آسایار</div>
          <div class="ecc-header__subtitle">( داشبورد مرکز پاسخگویی )</div>
          <div class="ecc-header__date">{{ ui.today }}</div>
        </div>
        <div class="ecc-row ecc-row--gap36">
          <!-- <div class="ecc-conn" :style="{ color: ui.connColor }">
            <span class="ecc-conn__dot" :style="{ background: ui.connColor }"></span>
            <span>{{ ui.connLabel }}</span>
          </div> -->
          <span dir="ltr" class="ecc-clock">{{ ui.clock }}</span>
        </div>
      </header>

      <section class="ecc-section">
        <div class="ecc-section__head">
          <span class="ecc-live-dot" :style="{ background: ui.connColor }"></span>
          <span class="ecc-section__title ecc-section__title--white">لحظه‌ای</span>
          <!-- <span class="ecc-section__hint">بروزرسانی با هر سیگنال</span> -->
          <span class="ecc-live-sep"></span>
          <span class="ecc-section__meta">
            آخرین بروزرسانی
            <span dir="ltr" class="ecc-section__meta-val">{{
              ui.lastSignal
            }}</span>
          </span>
        </div>

        <div class="ecc-live-grid">
          <div class="ecc-card ecc-card--queue" :style="{
            background: ui.queueBg,
            borderColor: ui.queueBorder,
          }">
            <div class="ecc-between">
              <span class="ecc-label">
                <span class="ecc-iconbox ecc-iconbox--lg" :style="{ background: ui.queueIconBg }">
                  <svg viewBox="0 0 24 24" width="27" height="27" fill="none" :stroke="ui.queueIconFg" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path
                      d="M5 22h14 M5 2h14 M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22 M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
                  </svg>
                </span>
                <span class="ecc-card__title-lg">صف انتظار (پشت خطی)</span>
              </span>
              <span class="ecc-pill" :class="{ 'ecc-blink': ui.alert }"
                :style="{ background: ui.queuePillBg, color: ui.queuePillFg }">{{ ui.queueStatus }}</span>
            </div>
            <div class="ecc-queue-grid">
              <div class="ecc-col ecc-col--gap6">
                <span class="ecc-queue__label">تعداد پشت خطی</span>
                <span class="ecc-queue__count" :style="{ color: ui.queueColor }">{{ ui.queue }}</span>
              </div>
              <div class="ecc-col ecc-col--gap6">
                <span class="ecc-queue__label">بیشترین زمان انتظار</span>
                <span dir="ltr" class="ecc-queue__max" :style="{ color: ui.queueColor }">{{ ui.maxWait }}</span>
              </div>
              <div class="ecc-col ecc-col--gap6">
                <span class="ecc-queue__label">میانگین انتظار</span>
                <span dir="ltr" class="ecc-queue__avg">{{ ui.avgWait }}</span>
              </div>
            </div>
          </div>

          <div class="ecc-card ecc-card--plain">
            <span class="ecc-label">
              <span class="ecc-iconbox ecc-iconbox--lg" style="background: #1a3166">
                <svg viewBox="0 0 24 24" width="27" height="27" fill="none" stroke="#7fb0ff" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
                </svg>
              </span>
              <span class="ecc-card__title">کاربران متصل</span>
            </span>
            <span class="ecc-big" style="color: #7fb0ff">{{
              ui.connected
            }}</span>
            <div class="ecc-col ecc-col--gap10">
              <span class="ecc-card__sub">{{ ui.connectedSub }}</span>
              <div class="ecc-bar">
                <div class="ecc-bar__fill" style="background: #4f8cff"
                  :style="{ width: ui.connectedPct, visibility: ui.connectedBar }"></div>
              </div>
            </div>
          </div>

          <div class="ecc-card ecc-card--free" :style="{ background: ui.freeBg, borderColor: ui.freeBorder }">
            <span class="ecc-label">
              <span class="ecc-iconbox ecc-iconbox--lg" :style="{ background: ui.freeIconBg }">
                <svg viewBox="0 0 24 24" width="27" height="27" fill="none" :stroke="ui.freeColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 3a4 4 0 1 0 0 8a4 4 0 1 0 0-8z M16 11l2 2 4-4" />
                </svg>
              </span>
              <span class="ecc-card__title">کاربران آزاد</span>
            </span>
            <span class="ecc-big" :style="{ color: ui.freeColor }">{{
              ui.free
            }}</span>
            <div class="ecc-col ecc-col--gap10">
              <span class="ecc-card__sub">آماده پاسخگویی</span>
              <div class="ecc-bar">
                <div class="ecc-bar__fill" :style="{ background: ui.freeColor, width: ui.freePct }"></div>
              </div>
            </div>
          </div>

          <div class="ecc-card ecc-card--plain">
            <span class="ecc-label">
              <span class="ecc-iconbox ecc-iconbox--lg" style="background: #1a3166">
                <svg viewBox="0 0 24 24" width="27" height="27" fill="none" stroke="#7fb0ff" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M10 10H6 M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2 M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14 M8 8v4 M9 18h6 M17 16a2 2 0 1 0 0 4a2 2 0 1 0 0-4z M7 16a2 2 0 1 0 0 4a2 2 0 1 0 0-4z" />
                </svg>
              </span>
              <span class="ecc-card__title">ماموریت‌های فعال</span>
            </span>
            <span class="ecc-big" style="color: #fff">{{
              ui.activeMissions
            }}</span>
            <span class="ecc-card__sub">آمبولانس در ماموریت</span>
          </div>
        </div>
      </section>

      <section class="ecc-section">
        <div class="ecc-section__head">
          <span class="ecc-shift-dot"></span>
          <span class="ecc-section__title ecc-section__title--soft">شیفت جاری</span>
          <span class="ecc-section__hint">تجمیعی از {{ shiftStart }} تا اکنون</span>
          <span class="ecc-progress">
            <span class="ecc-progress__fill" :style="{ width: ui.progress }"></span>
          </span>
          <span class="ecc-section__meta ecc-section__meta--nowrap">
            بروزرسانی
            <span dir="ltr" class="ecc-section__meta-val">{{
              ui.lastUpdate
            }}</span>
            · بعدی {{ ui.countdown }} ث
            <span v-if="aggError" class="ecc-err">· خطا در دریافت</span>
          </span>
        </div>

        <div class="ecc-stats">
          <div v-for="s in ui.stats" :key="s.label" class="ecc-stat">
            <span class="ecc-label ecc-label--gap10">
              <span class="ecc-iconbox ecc-iconbox--sm">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#8ea2c9" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path :d="s.icon" />
                </svg>
              </span>
              <span class="ecc-stat__label">{{ s.label }}</span>
            </span>
            <div class="ecc-stat__row">
              <span dir="ltr" class="ecc-stat__value">{{ s.value }}</span>
              <span class="ecc-stat__sub">{{ s.sub }}</span>
            </div>
          </div>
        </div>

        <div class="ecc-bottom">
          <div class="ecc-panel ecc-panel--trend">
            <div class="ecc-between">
              <span class="ecc-label">
                <span class="ecc-iconbox ecc-iconbox--md">
                  <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 7l-8.5 8.5-5-5L2 17 M16 7h6v6" />
                  </svg>
                </span>
                <span class="ecc-panel__title">روند تماس‌ها</span>
              </span>
              <div class="ecc-legend">
                <span class="ecc-legend__item">
                  <span class="ecc-legend__line" style="background: #4f8cff"></span>ورودی
                </span>
                <!-- <span class="ecc-legend__item">
                  <span class="ecc-legend__line" style="background: #ef4444"></span>رهاشده
                </span> -->
              </div>
            </div>

            <div class="ecc-chart" dir="ltr">
              <div class="ecc-yaxis" aria-hidden="true">
                <span v-for="(t, i) in ui.yTicks" :key="i" class="ecc-yaxis__tick" :style="{ top: t.top }">{{ t.label
                  }}</span>
              </div>
              <svg class="ecc-chart__svg" viewBox="0 0 600 200" preserveAspectRatio="none">
                <line x1="0" y1="0" x2="600" y2="0" stroke="#142242" />
                <line x1="0" y1="66" x2="600" y2="66" stroke="#142242" />
                <line x1="0" y1="133" x2="600" y2="133" stroke="#142242" />
                <line x1="0" y1="200" x2="600" y2="200" stroke="#25375f" />
                <!-- <path :d="ui.areaPath" fill="#4f8cff" fill-opacity="0.14" /> -->
                <path :d="ui.linePath" fill="none" stroke="#4f8cff" stroke-width="4" vector-effect="non-scaling-stroke"
                  stroke-linejoin="round" />
                <!-- <path :d="ui.abPath" fill="none" stroke="#ef4444" stroke-width="3" vector-effect="non-scaling-stroke"
                  stroke-dasharray="8 6" /> -->
              </svg>
              <div v-for="(p, i) in ui.trendPts" :key="i">
                <div class="ecc-hit" :style="{ left: p.x, top: p.y }"></div>
                <div class="ecc-dot" :style="{
                  left: p.x,
                  top: p.y,
                  width: p.dot,
                  height: p.dot,
                  background: p.dotBg,
                }"></div>
                <div class="ecc-dot-label" :style="{
                  left: p.x,
                  top: p.y,
                  padding: p.pad,
                  background: p.bg,
                  color: p.fg,
                  fontSize: p.fs,
                }">
                  {{ p.n }}
                </div>
                <div class="ecc-tip" dir="rtl" :style="{ left: p.x, top: p.y, transform: p.tipTransform }">
                  {{ p.tip }}
                </div>
              </div>
            </div>

            <div dir="ltr" class="ecc-hours">
              <span v-for="(h, i) in ui.hours" :key="i">{{ h }}</span>
            </div>
          </div>

          <div class="ecc-panel ecc-panel--std">
            <span class="ecc-label">
              <span class="ecc-iconbox ecc-iconbox--md">
                <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 14l4-4 M3.34 19a10 10 0 1 1 17.32 0" />
                </svg>
              </span>
              <span class="ecc-panel__title">سطح سرویس</span>
            </span>
            <div class="ecc-panel__body">
              <div class="ecc-ring ecc-ring--sl" :style="{ background: ui.slRing }">
                <div class="ecc-ring__inner ecc-ring__inner--sl">
                  {{ ui.slLabel }}
                </div>
              </div>
              <div class="ecc-sl-text">
                <span>پاسخ زیر {{ ui.slThrLabel }} ثانیه</span>
                <span>هدف: {{ ui.slGoalLabel }}</span>
                <span class="ecc-sl-text__strong">{{ ui.slWindowLabel }}</span>
              </div>
            </div>
          </div>

          <div class="ecc-panel ecc-panel--std">
            <span class="ecc-label">
              <span class="ecc-iconbox ecc-iconbox--md">
                <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21.21 15.89A10 10 0 1 1 8 2.83 M22 12A10 10 0 0 0 12 2v10z" />
                </svg>
              </span>
              <span class="ecc-panel__title">نتیجه تماس‌ها</span>
            </span>
            <div ref="resBody" class="ecc-panel__body ecc-panel__body--rel">
              <div ref="donut" class="ecc-ring ecc-ring--donut" :style="{ background: ui.donutBg }"
                @mousemove="onDonutMove" @mouseleave="clearResHover">
                <div ref="donutInner" class="ecc-ring__inner ecc-ring__inner--donut">
                  <span class="ecc-donut__num">{{ ui.resTotalNum }}</span>
                  <span class="ecc-donut__cap">پاسخ‌داده</span>
                </div>
              </div>
              <div class="ecc-results">
                <div v-for="(r, i) in ui.results" :key="i" class="ecc-results__row"
                  :class="{ 'ecc-results__row--hover': hoverRes === i }" @mouseenter="onResRowEnter(i, $event)"
                  @mouseleave="clearResHover">
                  <span class="ecc-results__swatch" :style="{ background: r.color }"></span>
                  <span class="ecc-results__label">{{ r.label }}</span>
                  <span class="ecc-results__pct">{{ r.pctLabel }}</span>
                </div>
              </div>
              <div v-if="hoverRes !== null && ui.results[hoverRes]" class="ecc-tip ecc-tip--res" dir="rtl"
                :style="{ left: resTip.x + 'px', top: resTip.y + 'px' }">
                <span class="ecc-results__swatch ecc-tip__swatch"
                  :style="{ background: ui.results[hoverRes].color }"></span>
                {{ ui.results[hoverRes].label }} · {{ ui.results[hoverRes].countLabel }} تماس ·
                {{ ui.results[hoverRes].pctLabel }}
              </div>
            </div>
          </div>

          <div class="ecc-panel ecc-panel--std">
            <span class="ecc-label">
              <span class="ecc-iconbox ecc-iconbox--md">
                <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M11 2v2 M5 2v2 M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1 M8 15a6 6 0 0 0 12 0v-3 M20 8a2 2 0 1 0 0 4a2 2 0 1 0 0-4z" />
                </svg>
              </span>
              <span class="ecc-panel__title">تشخیص‌های پرتکرار</span>
            </span>
            <div class="ecc-diag">
              <div v-for="(d, i) in ui.diagnoses" :key="i" class="ecc-diag__item">
                <div class="ecc-diag__head">
                  <span class="ecc-diag__label">{{ d.label }}</span>
                  <span class="ecc-diag__n">{{ d.n }}</span>
                </div>
                <div class="ecc-diag__track">
                  <div class="ecc-diag__fill" :style="{ width: d.w }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

const fa2 = (n) => String(n).padStart(2, '0').split('').map((c) => '۰۱۲۳۴۵۶۷۸۹'[c]).join('')
const FA = (n) => Number(n).toLocaleString('fa-IR').replace(/٬/g, '')
const T = (s) => {
  s = Math.max(0, Math.round(s))
  return (
    fa2(Math.floor(s / 3600)) + ':' + fa2(Math.floor((s % 3600) / 60)) + ':' + fa2(s % 60)
  )
}
const MS = (s) => {
  s = Math.max(0, Math.round(s))
  return fa2(Math.floor(s / 60)) + ':' + fa2(s % 60)
}

// رنگ‌های نتیجه‌ی تماس‌ها (به ترتیب آیتم‌های callsByTag)
const PALETTE = [
  '#4f8cff',
  '#22c55e',
  '#f59e0b',
  '#ef4444',
  '#64748b',
  '#a855f7',
  '#14b8a6',
  '#eab308',
  '#ec4899',
  '#94a3b8',
]
const SHIFTS = [
  { name: 'شیفت صبح', start: 7 },
  { name: 'شیفت عصر', start: 15 },
  { name: 'شیفت شب', start: 23 }
]

const IC = {
  phone:
    'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z',
  drop: 'M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91 M22 2L2 22',
  timer: 'M10 2h4 M12 14l3-3 M12 6a8 8 0 1 0 0 16a8 8 0 1 0 0-16z',
  talk: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  pulse: 'M22 12h-4l-3 9L9 3l-3 9H2',
  pin: 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z M12 7a3 3 0 1 0 0 6a3 3 0 1 0 0-6z',
  dnd: 'M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z M4.93 4.93l14.14 14.14',
}

function emptyLive() {
  return {
    total: null,
    connected: null,
    free: null,
    queue: null,
    active: null,
    avgWait: null,
    oldestSince: null,
    maxWait: null,
    recvAt: null,
    at: null,
  }
}

function emptyAggregate() {
  return {
    calls: 0,
    abandoned: 0,
    hourly: [],
    hourlyAb: [],
    hourLabels: [],
    diag: [],
    res: [],
    resLabels: [],
    avgAnswer: 0,
    avgTalk: 0,
    slPct: null,
    addr: 0,
    triaged: 0,
    dnd: 0,
    at: new Date(),
  }
}

function toDateOrNull(v) {
  if (!v) return null

  const d = new Date(typeof v === 'string' ? v.replace(/(\.\d{3})\d+/, '$1') : v)
  return isNaN(d.getTime()) ? null : d
}
const known = (v) => v !== null && v !== undefined

// کوچک‌ترین گام «گرد» (عدد صحیح) که ≥ v باشد؛ برای تیک‌های محور Y
const niceStep = (v) => {
  if (!(v > 1)) return 1
  const p = Math.pow(10, Math.floor(Math.log10(v)))
  const c = [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10].map((m) => m * p).filter((x) => Number.isInteger(x))
  return c.find((x) => x >= v) || p * 10
}

const faDigits = (str) => String(str).replace(/\d/g, (c) => '۰۱۲۳۴۵۶۷۸۹'[c])
const num = (v) => {
  const n = Number(v)
  return isFinite(n) ? n : 0
}
const numOrNull = (v) => {
  if (v === null || v === undefined || v === '') return null
  const n = Number(v)
  return isFinite(n) ? n : null
}
const val = (x) => num(x && (x.valueLong || x.valueDouble))

function parseDuration(v) {
  if (typeof v === 'number') return isFinite(v) ? v : NaN
  if (typeof v !== 'string') return NaN
  const t = v.trim()
  let m
  if ((m = t.match(/^(\d+)\.(\d{1,2}):(\d{2}):(\d{2})(\.\d+)?$/)))
    return +m[1] * 86400 + +m[2] * 3600 + +m[3] * 60 + +m[4]
  if ((m = t.match(/^(\d+):(\d{2}):(\d{2})(\.\d+)?$/)))
    return +m[1] * 3600 + +m[2] * 60 + +m[3]
  if ((m = t.match(/^(\d+):(\d{2})(\.\d+)?$/))) return +m[1] * 60 + +m[2]
  if ((m = t.match(/^PT(?:(\d+)H)?(?:(\d+)M)?(?:([\d.]+)S)?$/i)))
    return +(m[1] || 0) * 3600 + +(m[2] || 0) * 60 + +(m[3] || 0)
  if (/^\d+(\.\d+)?$/.test(t)) return +t
  return NaN
}
const DUR = (v, long) => {
  const s = parseDuration(v)
  if (isNaN(s)) return v === null || v === undefined || v === '' ? '—' : faDigits(v)
  return long ? T(s) : MS(s)
}
function fmtLabel(t) {
  const str = t === null || t === undefined ? '' : String(t).trim()
  const en = str
    .replace(/[۰-۹]/g, (c) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(c))
    .replace(/[٠-٩]/g, (c) => '٠١٢٣٤٥٦٧٨٩'.indexOf(c))
  let m
  if ((m = en.match(/^\d{4}[-/]\d{1,2}[-/]\d{1,2}[T\s]+(\d{1,2}):(\d{2})/)))
    return fa2(+m[1]) + ':' + fa2(+m[2])
  if ((m = en.match(/^(\d{1,2}):(\d{2})/))) return fa2(+m[1]) + ':' + fa2(+m[2])
  if (/^\d{1,2}$/.test(en)) return fa2(+en) + ':۰۰'
  return faDigits(en)
}

function mapAggregate(a) {
  const byDate = Array.isArray(a.callsByDate) ? a.callsByDate : []
  const byTag = Array.isArray(a.callsByTag) ? a.callsByTag : []
  const top = Array.isArray(a.topDiagnoses) ? a.topDiagnoses : []
  return {
    calls: num(a.numberOfCalls),
    abandoned: num(a.numberOfMissedCalls),
    abandonedPct: numOrNull(a.percentageOfMissedCalls),
    avgAnswer: a.triageAverage,
    avgTalk: a.talkAverage,
    triaged: num(a.triagedMissions),
    addr: num(a.confirmedLocations),
    dnd: a.dndDuration,
    hourly: byDate.map(val),
    hourlyAb: byDate.map((x) => num(x && x.subItemValue)),
    hourLabels: byDate.map((x) => fmtLabel(x && x.title)),
    res: byTag.map(val),
    resLabels: byTag.map((x) => String((x && x.title) || '')),
    diag: top.map((x) => ({ l: String((x && x.title) || ''), n: val(x) })),
    slPct: numOrNull(a.serviceLevelPercentage),
    slMin: numOrNull(a.serviceLevelDurationInMinutes),
    slSec: numOrNull(a.serviceLevelMaxAcceptDurationInSeconds),
    slThr: numOrNull(a.serviceLevelThreshold),
    // زمان سرور (currentDate پاسخ API)؛ اگر نبود، زمان دریافت
    at: toDateOrNull(a.currentDate) || new Date(),
    // شروع شیفت جاری (از سرور)
    shiftStart: toDateOrNull(a.shiftStartDate),
  }
}

const unwrap = (res) =>
  res && res.numberOfCalls === undefined && res.data ? res.data : res

function normalizeAgg(v) {
  return mapAggregate(unwrap(v))
}

export default {
  name: 'EmergencyCallDashboard',

  props: {
    refreshTimerInMinute: { type: Number, default: 2 },
    waitThreshold: { type: Number, default: 120 },
    slGoalPct: { type: Number, default: 90 },
    liveData: { type: Object, default: null },
    aggregateData: { type: Object, default: null },
    fetchAggregate: { type: Function, default: null },
    timeZone: { type: String, default: 'Asia/Tehran' },
  },

  data() {
    return {
      logo: require('@/assets/images/SetareHayat.png'),
      agg: this.aggregateData ? normalizeAgg(this.aggregateData) : null,
      aggLoading: false,
      aggError: false,
      lastFetchAt: 0,
      live: this.liveData ? this.normalizeLive(this.liveData) : null,
      left: 0,
      clockOffset: null,
      now: new Date(),
      connState: 'Disconnected',
      scale: 1,
      ox: 0,
      oy: 0,
      hoverRes: null,
      resTip: { x: 0, y: 0 },
    }
  },

  computed: {
    ui() {
      const ready = !!this.agg
      const agg = this.agg || emptyAggregate()
      const L = this.live || emptyLive()
      const now = this.now
      const { scale, ox, oy } = this
      const devNow = Date.now()
      const hasMaxWait = known(L.maxWait) || known(L.oldestSince)
      const maxWaitSec =
        L.queue > 0
          ? known(L.maxWait)
            ? L.maxWait + Math.max(0, devNow - L.recvAt) / 1000
            : known(L.oldestSince)
              ? Math.max(0, (now.getTime() - L.oldestSince) / 1000)
              : 0
          : 0
      const d = {
        ...agg,
        total: L.total,
        connected: L.connected,
        free: L.free,
        queue: L.queue,
        maxWait: maxWaitSec,
        avgWait: Math.min(L.avgWait, maxWaitSec),
        active: L.active,
      }
      const hasSignal = !!L.at
      const clockKnown = this.clockOffset !== null
      const tz = this.timeZone || undefined
      const tf = (t) =>
        t.toLocaleTimeString('fa-IR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: tz,
        })
      const interval = this.refreshSec
      const left = Math.min(this.left, interval)
      const thr = this.waitThreshold

      const slGoal = this.slGoalPct
      const slSec =
        ready && agg.slSec !== null && agg.slSec !== undefined
          ? agg.slSec
          : null
      const slWindow =
        ready && agg.slMin ? FA(agg.slMin) + ' دقیقه اخیر' : '—'
      const alert = d.maxWait > thr || d.queue > 15
      const warn = !alert && (d.maxWait > thr / 2 || d.queue > 8)
      const noFree = known(L.free) && d.free === 0

      const slKnown =
        ready && agg.slPct !== null && agg.slPct !== undefined
      const sl = slKnown
        ? Math.max(0, Math.min(100, Math.round(agg.slPct)))
        : 0
      const slColor =
        sl >= slGoal ? '#22c55e' : sl >= slGoal - 10 ? '#f59e0b' : '#ef4444'

      const maxOf = (arr) => (arr.length ? Math.max(...arr) : 0)
      const dataMax = Math.max(maxOf(d.hourly), maxOf(d.hourlyAb))
      const yStep = niceStep((dataMax * 1.05) / 3)
      const max = yStep * 3
      const pts = (arr) =>
        arr.map((v, i) => [
          arr.length > 1 ? (i * 600) / (arr.length - 1) : 300,
          200 - (v / max) * 200,
        ])
      const toPath = (p) =>
        p
          .map(
            (q, i) => (i ? 'L' : 'M') + q[0].toFixed(1) + ' ' + q[1].toFixed(1)
          )
          .join(' ')
      const lp = pts(d.hourly)
      const resTotal = d.res.reduce((a, b) => a + b, 0)
      const resSum = resTotal || 1
      const resMeta = d.res.map((v, i) => ({
        label: d.resLabels[i],
        color: PALETTE[i % PALETTE.length],
      }))
      let acc = 0
      const hr = this.hoverRes
      const resArcs = []
      const stops = d.res.map((v, i) => {
        const s = acc
        acc += (v / resSum) * 100
        resArcs.push({ start: s * 3.6, end: acc * 3.6 })
        // هنگام هاور، بقیه‌ی قطعه‌ها کم‌رنگ می‌شوند
        const c = hr === null || hr === i ? resMeta[i].color : resMeta[i].color + '55'
        return `${c} ${s}% ${acc}%`
      })
      const pk = d.hourly.length ? d.hourly.indexOf(maxOf(d.hourly)) : -1
      const diagList = d.diag
        .slice()
        .sort((a, b) => b.n - a.n)
        .slice(0, 5)
      const diagTop = diagList.length ? diagList[0].n || 1 : 1
      const abPct =
        d.abandonedPct !== null && d.abandonedPct !== undefined
          ? d.abandonedPct
          : d.calls
            ? (d.abandoned / d.calls) * 100
            : 0

      const many = d.hourly.length > 12
      const hoursAll = d.hourLabels || []
      const step = Math.ceil(hoursAll.length / 12) || 1

      return {
        stageTransform: `translate(${ox}px, ${oy}px) scale(${scale})`,

        today: clockKnown
          ? now.toLocaleDateString('fa-IR', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            timeZone: tz,
          })
          : '—',
        lastUpdate: ready ? tf(agg.at) : '--:--:--',
        lastSignal: hasSignal ? tf(L.at) : '--:--:--',
        clock: clockKnown ? tf(now) : '--:--:--',
        connLabel: this.connState === 'Connected' ? 'اتصال زنده' : 'قطع ارتباط با سرور',
        connColor: this.connState === 'Connected' ? '#4ade80' : '#ff6b6b',
        countdown: FA(left),
        progress: ((interval - left) / interval) * 100 + '%',

        alert,
        queue: known(L.queue) ? FA(d.queue) : '—',
        maxWait: known(L.queue) && hasMaxWait ? MS(d.maxWait) : '—',
        avgWait: known(L.avgWait) ? MS(L.avgWait) : '—',
        queueStatus: !known(L.queue)
          ? 'در انتظار داده'
          : alert
            ? 'وضعیت بحرانی'
            : warn
              ? 'نیاز به توجه'
              : 'عادی',
        queueBg: alert ? '#3a0d16' : '#0f1f45',
        queueBorder: alert ? '#ef4444' : warn ? '#f59e0b' : '#24407a',
        queuePillBg: !known(L.queue)
          ? '#1a3166'
          : alert
            ? '#ef4444'
            : warn
              ? '#f59e0b'
              : '#14532d',
        queuePillFg: !known(L.queue)
          ? '#a9badd'
          : alert
            ? '#fff'
            : warn
              ? '#1a1205'
              : '#bbf7d0',
        queueColor: alert ? '#ff6b6b' : warn ? '#fbbf24' : '#ffffff',
        queueIconBg: alert ? '#5c1420' : warn ? '#3d2a08' : '#1a3166',
        queueIconFg: alert ? '#ff6b6b' : warn ? '#fbbf24' : '#7fb0ff',

        connected: known(L.connected) ? FA(d.connected) : '—',
        // تعداد کل اپراتورها در سوکت نیست؛ تا وقتی ندهند فقط «وارد شده» نمایش داده می‌شود
        connectedSub: L.total > 0 ? 'از ' + FA(L.total) + ' ایستگاه' : 'کاربر وارد شده',
        connectedBar: L.total > 0 && known(L.connected) ? 'visible' : 'hidden',
        connectedPct:
          (L.total > 0 && known(L.connected) ? (L.connected / L.total) * 100 : 0) + '%',
        free: known(L.free) ? FA(d.free) : '—',

        freePct:
          (!known(L.free)
            ? 0
            : L.total > 0
              ? (L.free / L.total) * 100
              : L.connected > 0
                ? (L.free / L.connected) * 100
                : 0) + '%',
        freeColor: !known(L.free) ? '#a9badd' : noFree ? '#ff6b6b' : '#4ade80',
        freeBg: noFree ? '#3a0d16' : '#0f1f45',
        freeBorder: noFree ? '#ef4444' : '#24407a',
        freeIconBg: !known(L.free) ? '#1a3166' : noFree ? '#5c1420' : '#0f3320',
        activeMissions: known(L.active) ? FA(d.active) : '—',

        slLabel: slKnown ? FA(sl) + '٪' : '—',
        slRing: slKnown
          ? `conic-gradient(${slColor} 0 ${sl}%, #13203f ${sl}% 100%)`
          : '#13203f',
        slThrLabel: slSec !== null ? FA(slSec) : '—',
        slGoalLabel: FA(slGoal) + '٪',
        slWindowLabel: slWindow,

        stats: [
          {
            label: 'تماس‌های شیفت',
            icon: IC.phone,
            value: FA(d.calls),
            sub: '',
          },
          {
            label: 'تماس بدون پاسخ',
            icon: IC.drop,
            value: FA(abPct.toFixed(1)) + '٪',
            sub: FA(d.abandoned) + ' تماس',
          },
          {
            label: 'میانگین زمان تریاژ',
            icon: IC.timer,
            value: DUR(d.avgAnswer, false),
            sub: '',
          },
          {
            label: 'میانگین مکالمه',
            icon: IC.talk,
            value: DUR(d.avgTalk, false),
            sub: '',
          },
          {
            label: 'تماس تریاژشده',
            icon: IC.pulse,
            value: FA(d.triaged),
            sub: '',
          },
          { label: 'تایید آدرس', icon: IC.pin, value: FA(d.addr), sub: '' },
          { label: 'مدت DND', icon: IC.dnd, value: DUR(d.dnd, true), sub: '' },
        ].map((s) => (ready ? s : { ...s, value: '—', sub: '' })),

        trendPts: lp.map((q, i) => {
          const isPk = i === pk
          const below = q[1] / 2 < 30
          const tx = lp.length > 1 && i === 0 ? '-15%' : lp.length > 1 && i === lp.length - 1 ? '-85%' : '-50%'
          return {
            tip: (hoursAll[i] ? hoursAll[i] + ' · ' : '') + FA(d.hourly[i]) + ' تماس',
            tipTransform: `translate(${tx}, ${below ? '90%' : '-190%'})`,
            x: q[0] / 6 + '%',
            y: q[1] / 2 + '%',
            n: !many || isPk ? FA(d.hourly[i]) : '',
            dot: isPk ? '16px' : '11px',
            dotBg: isPk ? '#4f8cff' : '#0b1630',
            bg: isPk ? '#4f8cff' : 'transparent',
            fg: isPk ? '#fff' : '#c9d6f2',
            fs: isPk ? '22px' : '18px',
            pad: isPk ? '2px 10px' : '0',
          }
        }),
        yTicks: [3, 2, 1, 0].map((k) => ({
          label: FA(yStep * k),
          top: ((3 - k) / 3) * 100 + '%',
        })),
        linePath: toPath(lp),
        areaPath: lp.length ? toPath(lp) + ' L600 200 L0 200 Z' : '',
        abPath: toPath(pts(d.hourlyAb)),
        hours: hoursAll.map((h, i) => (i % step === 0 ? h : '')),

        answered: ready ? FA(Math.max(0, d.calls - d.abandoned)) : '—',
        donutBg: resTotal ? `conic-gradient(${stops.join(',')})` : '#13203f',
        resTotalNum: resTotal ? FA(resTotal) : '—',
        resArcs: resTotal ? resArcs : [],
        results: resMeta.map((r, i) => ({
          ...r,
          pctLabel: FA(Math.round((d.res[i] / resSum) * 100)) + '٪',
          countLabel: FA(d.res[i]),
        })),
        diagnoses: diagList.map((x) => ({
          label: x.l,
          n: FA(x.n),
          w: (x.n / diagTop) * 100 + '%',
        })),
      }
    },
    refreshSec() {
      const minutes = Number(this.refreshTimerInMinute);
      return (isFinite(minutes) && minutes > 0 ? minutes : 2) * 60;
    },
    // /* ── شیفت ── */
    shift() {
      // ساعت فعلی به وقت منطقه‌ی زمانی صفحه (نه ساعت مرورگر) و بدون وابستگی به agg
      const hr = Number(
        new Intl.DateTimeFormat('en-US', {
          hour: 'numeric',
          hourCycle: 'h23',
          timeZone: this.timeZone || undefined,
        }).format(this.now)
      )
      return hr >= 23 || hr < 7 ? SHIFTS[2] : hr >= 15 ? SHIFTS[1] : SHIFTS[0]
    },
    shiftStart() {
      const d = this.agg && this.agg.shiftStart
      if (d) {
        return d.toLocaleTimeString('fa-IR', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone: this.timeZone || undefined,
        })
      }
      return fa2(this.shift.start) + ':۰۰'
    },
  },

  watch: {
    liveData: {
      deep: true,
      handler(v) {
        this.live = v ? this.normalizeLive(v) : null
      },
    },
    aggregateData(v) {
      if (v) {
        this.agg = normalizeAgg(v)
        this.syncClock(unwrap(v).currentDate)
      }
    },
    refreshSec: {
      immediate: true,
      handler(newVal) {
        this.left = newVal;
      },
    },
  },

  mounted() {
    this.setHomeMenuHidden(true)
    this.fit()
    window.addEventListener('resize', this.fit)
    if (typeof ResizeObserver !== 'undefined') {
      this.ro = new ResizeObserver(this.fit)
      this.ro.observe(this.$refs.host)
    }

    this.left = this.refreshSec;

    const st = this.$mainSignalr?.connection?.state
    if (st) this.connState = st

    this.timer = setInterval(() => {
      const st = this.$mainSignalr?.connection?.state
      if (st) this.connState = st
      this.now = this.serverNow();
      if (this.left <= 1) {
        this.left = this.refreshSec;
        this.loadAggregate(true);
        this.$emit('refresh');
      } else {
        this.left = Math.min(this.left, this.refreshSec) - 1;
      }
    }, 1000);
  },

  beforeDestroy() {
    this.setHomeMenuHidden(false)
    clearInterval(this.timer)
    window.removeEventListener('resize', this.fit)
    if (this.ro) this.ro.disconnect()
  },
  methods: {
    setHomeMenuHidden(hidden) {
      const home = this.$root.$refs.Home
      if (home && home.setMenuHidden) home.setMenuHidden(hidden)
    },

    openMenu() {
      const home = this.$root.$refs.Home
      if (home && home.openMenu) home.openMenu()
    },

    async loadAggregate(force) {
      if (!this.fetchAggregate || this.aggLoading) return
      if (force !== true && Date.now() - this.lastFetchAt < 5000) return
      this.aggLoading = true
      this.lastFetchAt = Date.now()
      try {
        const data = unwrap(await this.fetchAggregate())
        if (!data || typeof data !== 'object') throw new Error('empty response')
        this.agg = mapAggregate(data)
        this.syncClock(data.currentDate)
        this.aggError = false
      } catch (e) {
        this.aggError = true
        this.$emit('error', e)
      } finally {
        this.aggLoading = false
      }
    },

    setLive(payload) {
      this.live = payload ? this.normalizeLive(payload) : null
    },

    syncClock(serverDate) {
      const d = toDateOrNull(serverDate)
      if (!d) return
      this.clockOffset = d.getTime() - Date.now()
      this.now = this.serverNow()
    },

    serverNow() {
      return new Date(Date.now() + (this.clockOffset || 0))
    },

    normalizeLive(v) {
      const at = toDateOrNull(v.at)
      if (at && this.clockOffset === null) this.syncClock(at)
      const since = v.oldestSince ? new Date(v.oldestSince).getTime() : NaN
      return {
        total: numOrNull(v.total),
        connected: numOrNull(v.connected),
        free: numOrNull(v.free),
        queue: numOrNull(v.queue),
        active: numOrNull(v.active),
        avgWait: numOrNull(v.avgWait),
        maxWait: numOrNull(v.maxWait),
        oldestSince: isFinite(since) ? since : null,
        recvAt: Date.now(),
        at,
      }
    },

    // موقعیت tooltip نتیجه‌ی تماس‌ها (نسبت به بدنه‌ی پنل، با جبران scale صفحه)
    resTipAt(clientX, clientY) {
      const body = this.$refs.resBody
      if (!body) return
      const r = body.getBoundingClientRect()
      const s = this.scale || 1
      this.resTip = { x: (clientX - r.left) / s, y: (clientY - r.top) / s }
    },
    // تشخیص قطعه‌ی دونات زیر موس (conic-gradient از بالا و ساعت‌گرد شروع می‌شود)
    onDonutMove(e) {
      const ring = this.$refs.donut
      const arcs = this.ui.resArcs
      if (!ring || !arcs.length) return this.clearResHover()
      const r = ring.getBoundingClientRect()
      const dx = e.clientX - (r.left + r.width / 2)
      const dy = e.clientY - (r.top + r.height / 2)
      const dist = Math.hypot(dx, dy)
      const inner = this.$refs.donutInner
      const hole = inner ? inner.getBoundingClientRect().width / 2 : (r.width / 2) * 0.66
      if (dist < hole || dist > r.width / 2) return this.clearResHover()
      let deg = (Math.atan2(dx, -dy) * 180) / Math.PI
      if (deg < 0) deg += 360
      let idx = arcs.findIndex((a) => deg >= a.start && deg < a.end)
      if (idx === -1) {
        // خطای گرد کردن در انتهای دایره → آخرین قطعه‌ی غیرصفر
        for (let k = arcs.length - 1; k >= 0; k--) {
          if (arcs[k].end > arcs[k].start) { idx = k; break }
        }
      }
      if (idx === -1) return this.clearResHover()
      this.hoverRes = idx
      this.resTipAt(e.clientX, e.clientY)
    },
    onResRowEnter(i, e) {
      this.hoverRes = i
      const r = e.currentTarget.getBoundingClientRect()
      this.resTipAt(r.left + r.width / 2, r.top)
    },
    clearResHover() {
      this.hoverRes = null
    },

    fit() {
      const el = this.$refs.host
      if (!el) return
      const w = el.clientWidth
      const h = el.clientHeight
      if (!w || !h) return
      const s = Math.min(w / 1920, h / 1080)
      this.scale = s
      this.ox = (w - 1920 * s) / 2
      this.oy = (h - 1080 * s) / 2
    },
  },
}
</script>

<style scoped>
@keyframes ecc-pulse {
  0% {
    box-shadow: 0 0 0 0 rgb(166, 0, 255);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

@keyframes ecc-blink {
  50% {
    opacity: 0.55;
  }
}

/* ───── Host / stage ───── */
.ecc-host {
  position: relative;
  width: 100%;
  height: 100%;
  background: #040a18;
  overflow: hidden;
  /* font-family: Vazirmatn, system-ui, sans-serif;*/
  line-height: normal;
  text-align: start;
}

.ecc-host--fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ecc-logo-btn {
  cursor: pointer;
  transition: transform 0.15s;
}

.ecc-logo-btn:hover {
  transform: scale(1.12);
}

.ecc-host *,
.ecc-host *::before,
.ecc-host *::after {
  box-sizing: border-box;
}

.ecc-stage {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  transform-origin: 0 0;
  background: #060d20;
  color: #eaf0fd;
  /* font-family: Vazirmatn, system-ui, sans-serif; */
  padding: 24px 32px;
  display: grid;
  grid-template-rows: 80px 356px minmax(0, 1fr);
  gap: 20px;
}

/* ───── Generic helpers ───── */
.ecc-row {
  display: flex;
  align-items: center;
}

.ecc-row--gap20 {
  gap: 20px;
}

.ecc-row--gap36 {
  gap: 36px;
}

.ecc-col {
  display: flex;
  flex-direction: column;
}

.ecc-col--gap6 {
  gap: 6px;
}

.ecc-col--gap10 {
  gap: 10px;
}

.ecc-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ecc-label {
  display: flex;
  align-items: center;
  gap: 14px;
}

.ecc-label--gap10 {
  gap: 10px;
}

.ecc-iconbox {
  flex: none;
  display: grid;
  place-items: center;
}

.ecc-iconbox--lg {
  width: 48px;
  height: 48px;
  border-radius: 14px;
}

.ecc-iconbox--md {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #13203f;
}

.ecc-iconbox--sm {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #13203f;
}

/* ───── Header ───── */
.ecc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: #0b1630;
  border: 1px solid #172447;
  border-radius: 18px;
  padding: 0 28px;
  position: relative;
  overflow: hidden;
}

.ecc-header__title {
  font-size: 40px;
  font-weight: 800;
}

.ecc-header__subtitle {
  font-size: 20px;
  font-weight: 500;
}

.ecc-header__date {
  font-size: 22px;
  color: #93a6cf;
}

.ecc-conn {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 21px;
}

.ecc-conn__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.ecc-clock {
  font-size: 34px;
  font-weight: 700;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

/* ───── Section heads ───── */
.ecc-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

.ecc-section__head {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
}

.ecc-section__title {
  font-size: 24px;
  font-weight: 800;
}

.ecc-section__title--white {
  color: #fff;
}

.ecc-section__title--soft {
  color: #c9d6f2;
}

.ecc-section__hint {
  font-size: 20px;
  color: #93a6cf;
}

.ecc-section__meta {
  font-size: 19px;
  color: #93a6cf;
  font-variant-numeric: tabular-nums;
}

.ecc-section__meta--nowrap {
  white-space: nowrap;
}

.ecc-section__meta-val {
  color: #c9d6f2;
  font-weight: 700;
}

.ecc-live-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  /* background: #22c55e; */
  animation: ecc-pulse 2s infinite;
}

.ecc-live-sep {
  flex: 1;
  height: 1px;
  background: #24407a;
  margin: 0 12px;
}

.ecc-shift-dot {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: #5b6f99;
}

.ecc-progress {
  flex: 1;
  height: 6px;
  border-radius: 4px;
  background: #13203f;
  margin: 0 12px;
  overflow: hidden;
  display: flex;
}

.ecc-progress__fill {
  height: 100%;
  border-radius: 4px;
  background: #5b7fc7;
  transition: width 1s linear;
}

/* ───── Realtime cards ───── */
.ecc-live-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 3.5fr) minmax(0, 2fr) minmax(0, 2fr) minmax(0,
      2fr);
  gap: 20px;
}

.ecc-card {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ecc-card--queue {
  border: 2px solid;
  padding: 22px 30px;
  transition: background 0.4s;
}

.ecc-card--plain {
  background: #0f1f45;
  border: 1px solid #24407a;
  padding: 22px 26px;
}

.ecc-card--free {
  border: 2px solid;
  padding: 22px 26px;
}

.ecc-card__title-lg {
  font-size: 28px;
  font-weight: 700;
}

.ecc-card__title {
  font-size: 26px;
  font-weight: 600;
  color: #c9d6f2;
}

.ecc-card__sub {
  font-size: 22px;
  color: #93a6cf;
}

.ecc-big {
  font-size: 120px;
  font-weight: 900;
  line-height: 0.9;
}

.ecc-pill {
  font-size: 22px;
  font-weight: 700;
  padding: 6px 18px;
  border-radius: 30px;
}

.ecc-blink {
  animation: ecc-blink 1s infinite;
}

.ecc-queue-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 24px;
  align-items: end;
}

.ecc-queue__label {
  font-size: 24px;
  color: #a9badd;
}

.ecc-queue__count {
  font-size: 150px;
  font-weight: 900;
  line-height: 0.9;
}

.ecc-queue__max {
  font-size: 84px;
  font-weight: 800;
  line-height: 0.95;
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}

.ecc-queue__avg {
  font-size: 52px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}

.ecc-bar {
  height: 10px;
  border-radius: 6px;
  background: #1a3166;
  overflow: hidden;
}

.ecc-bar__fill {
  height: 100%;
  border-radius: 6px;
}

/* ───── Stats row ───── */
.ecc-stats {
  height: 132px;
  flex: none;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 16px;
}

.ecc-stat {
  background: #0b1630;
  border: 1px solid #172447;
  border-radius: 18px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ecc-stat__label {
  font-size: 21px;
  color: #a9badd;
  white-space: nowrap;
}

.ecc-stat__row {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.ecc-stat__value {
  font-size: 46px;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ecc-stat__sub {
  font-size: 19px;
  color: #93a6cf;
  font-weight: 600;
  white-space: nowrap;
}

/* ───── Bottom panels ───── */
.ecc-bottom {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 4.4fr) minmax(0, 2.6fr) minmax(0, 3fr) minmax(0,
      3fr);
  gap: 16px;
}

.ecc-panel {
  background: #0b1630;
  border: 1px solid #172447;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
}

.ecc-panel--trend {
  padding: 20px 26px;
  gap: 12px;
  min-height: 0;
}

.ecc-panel--std {
  padding: 20px 24px;
  gap: 14px;
}

.ecc-panel__title {
  font-size: 24px;
  font-weight: 700;
}

.ecc-panel__body {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

/* trend */
.ecc-legend {
  display: flex;
  gap: 20px;
  font-size: 19px;
  color: #a9badd;
}

.ecc-legend__item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ecc-legend__line {
  width: 22px;
  height: 5px;
  border-radius: 3px;
}

.ecc-chart {
  flex: 1;
  min-height: 0;
  position: relative;
  margin-left: 10px;
  /* جا برای برچسب‌های محور Y */
}

.ecc-yaxis {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -52px;
  width: 40px;
}

.ecc-yaxis__tick {
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 1;
  color: #8ea2c9;
  font-variant-numeric: tabular-nums;
}

.ecc-chart__svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.ecc-dot {
  position: absolute;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 3px solid #4f8cff;
}

.ecc-dot-label {
  position: absolute;
  transform: translate(-50%, -150%);
  border-radius: 8px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

/* ───── Hover tooltip ───── */
.ecc-hit {
  position: absolute;
  width: 34px;
  height: 34px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  z-index: 3;
}

.ecc-dot {
  transition: transform 0.12s;
}

.ecc-hit:hover~.ecc-dot {
  transform: translate(-50%, -50%) scale(1.35);
}

.ecc-tip {
  position: absolute;
  z-index: 5;
  padding: 4px 12px;
  border-radius: 8px;
  background: #1b2a52;
  border: 1px solid #3a5190;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.12s;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
}

.ecc-hit:hover~.ecc-tip {
  opacity: 1;
}

.ecc-tip--res {
  opacity: 1;
  transform: translate(-50%, -140%);
}

.ecc-tip__swatch {
  display: inline-block;
  vertical-align: middle;
  margin-inline-end: 6px;
}

.ecc-panel__body--rel {
  position: relative;
}

.ecc-results__row--hover .ecc-results__label {
  color: #fff;
}

.ecc-hours {
  display: flex;
  justify-content: space-between;
  margin-left: 52px;
  /* هم‌تراز با نمودار */
  font-size: 17px;
  color: #8ea2c9;
}

/* rings */
.ecc-ring {
  width: 150px;
  height: 150px;
  flex: none;
  border-radius: 50%;
  display: grid;
  place-items: center;
}

.ecc-ring__inner {
  border-radius: 50%;
  background: #0b1630;
}

.ecc-ring__inner--sl {
  width: 116px;
  height: 116px;
  display: grid;
  place-items: center;
  font-size: 38px;
  font-weight: 800;
}

.ecc-ring__inner--donut {
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ecc-sl-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 19px;
  color: #a9badd;
  min-width: 0;
}

.ecc-sl-text__strong {
  color: #c9d6f2;
  font-weight: 600;
}

.ecc-donut__num {
  font-size: 26px;
  font-weight: 800;
}

.ecc-donut__cap {
  font-size: 15px;
  color: #8ea2c9;
}

.ecc-results {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.ecc-results__row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 19px;
}

.ecc-results__swatch {
  width: 13px;
  height: 13px;
  border-radius: 4px;
  flex: none;
}

.ecc-results__label {
  flex: 1;
  color: #c9d6f2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecc-results__pct {
  font-weight: 700;
}

/* diagnoses */
.ecc-diag {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  justify-content: flex-start;
  gap: 15px;
  flex: 1;
}

.ecc-diag__item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ecc-diag__head {
  display: flex;
  justify-content: space-between;
  font-size: 19px;
}

.ecc-diag__label {
  color: #c9d6f2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ecc-diag__head {
  gap: 12px;
}

.ecc-err {
  color: #ff6b6b;
  font-weight: 700;
}

.ecc-diag__n {
  font-weight: 700;
}

.ecc-diag__track {
  height: 8px;
  background: #13203f;
  border-radius: 6px;
  overflow: hidden;
}

.ecc-diag__fill {
  height: 100%;
  border-radius: 6px;
  background: #5b7fc7;
  transition: width 0.6s;
}
</style>